module.exports = __webpack_public_path__ + "img/symbol_10.c21a0f34.png";